import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/Subscription';
import { DepartmentAssetPage, DepartmentAssetRow, WorkflowError } from '../../../models/employee-asset.model';
import { EmployeeAssetsService } from '../../../services/employee-assets.service';
import { ASSET } from './asset.constants';
import { workflowTrackBy } from './asset.helpers';

const DEPARTMENT_ASSETS = {
  failed: 'DEPARTMENT_ASSETS_FAILED', denied: 'DEPARTMENT_ASSETS_DENIED',
  conflict: 'DEPARTMENT_ASSETS_CONFLICT', maxQueryLength: 100
};
interface DepartmentAssetGroup { employeeId: string; employeeName: string; rows: DepartmentAssetRow[]; }

@Component({selector: 'app-department-assets-modal', templateUrl: './department-assets-modal.component.html',
  styleUrls: ['./department-assets-modal.component.css']})
export class DepartmentAssetsModalComponent implements OnInit, OnDestroy {
  departmentId: string;
  departmentName: string;
  searchText = ASSET.empty;
  query = ASSET.empty;
  page = ASSET.zero;
  rows: DepartmentAssetRow[] = [];
  groups: DepartmentAssetGroup[] = [];
  hasMore = false;
  loading = false;
  denied = false;
  errorKey = ASSET.empty;
  readonly constants = ASSET;
  readonly departmentConstants = DEPARTMENT_ASSETS;
  readonly trackBy = workflowTrackBy;
  private request: Subscription;
  private generation = ASSET.zero;
  private destroyed = false;

  constructor(public modal: NgbActiveModal, private api: EmployeeAssetsService) {}

  ngOnInit(): void { this.load(); }

  trackEmployee(index: number, group: DepartmentAssetGroup): string { return group.employeeId; }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.generation++;
    if (this.request) { this.request.unsubscribe(); }
    this.rows = [];
    this.groups = [];
  }

  search(): void {
    const query = this.searchText.trim().slice(ASSET.zero, DEPARTMENT_ASSETS.maxQueryLength);
    if (this.denied || this.loading && query === this.query && this.page === ASSET.zero) { return; }
    this.query = query;
    this.page = ASSET.zero;
    this.load();
  }

  movePage(direction: number): void {
    if (this.loading || this.errorKey || this.denied ||
      direction === ASSET.one && !this.hasMore || direction === -ASSET.one && this.page === ASSET.zero) { return; }
    this.page += direction;
    this.load();
  }

  retry(): void {
    if (!this.loading && !this.denied) { this.load(); }
  }

  private load(): void {
    if (this.destroyed) { return; }
    const generation = ++this.generation;
    const departmentId = this.departmentId;
    if (this.request) { this.request.unsubscribe(); }
    this.rows = []; this.groups = []; this.hasMore = false; this.errorKey = ASSET.empty; this.loading = true;
    this.request = this.api.department(departmentId, {page: this.page, size: ASSET.pageSize, q: this.query})
      .subscribe(result => {
        if (this.isCurrent(generation, departmentId)) { this.accept(result); }
      }, error => {
        if (this.isCurrent(generation, departmentId)) { this.fail(error); }
      });
  }

  private isCurrent(generation: number, departmentId: string): boolean {
    return !this.destroyed && generation === this.generation && departmentId === this.departmentId;
  }

  private accept(result: DepartmentAssetPage): void {
    this.loading = false;
    if (!result || !Array.isArray(result.items) || typeof result.hasMore !== BOOLEAN_TYPE) {
      this.errorKey = DEPARTMENT_ASSETS.failed;
      return;
    }
    this.rows = result.items;
    this.groups = [];
    this.rows.forEach(row => {
      let group = this.groups.find(item => item.employeeId === row.employeeId);
      if (!group) {
        group = {employeeId: row.employeeId, employeeName: row.employeeName, rows: []};
        this.groups.push(group);
      }
      group.rows.push(row);
    });
    this.hasMore = result.hasMore;
  }

  private fail(error: WorkflowError): void {
    this.loading = false; this.rows = []; this.groups = []; this.hasMore = false;
    this.denied = !!error && (error.status === ASSET.forbidden || error.status === ASSET.unauthorized);
    this.errorKey = this.denied ? DEPARTMENT_ASSETS.denied : error && error.status === ASSET.conflict
      ? DEPARTMENT_ASSETS.conflict : DEPARTMENT_ASSETS.failed;
  }
}
const BOOLEAN_TYPE = 'boolean';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/employee-assets/department-assets-modal.component.ts